export default "__VITE_ASSET__a6b51368__"